import { render, staticRenderFns } from "./supporting_institutions.vue?vue&type=template&id=5c26d4b9&scoped=true&"
import script from "./supporting_institutions.vue?vue&type=script&lang=js&"
export * from "./supporting_institutions.vue?vue&type=script&lang=js&"
import style0 from "./supporting_institutions.vue?vue&type=style&index=0&id=5c26d4b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c26d4b9",
  null
  
)

export default component.exports